/* eslint-disable no-unused-vars */
import CryptoJS from 'crypto-js';
import {
  APP_ADMIN_MESSAGE,
  APP_AGENT_LOGO_URL,
  APP_CONFIG,
  APP_PREF_LANGUAGE,
  APP_SWITCHBACK_AUTH_TOKEN,
  APP_TRAIN_RETURN_BOOKING,
  APP_USER_AUTH,
  APP_USER_PROFILE,
  APP_EMPLOYEE_EMAIL,
} from '../../saas/AppStorageStaticNames';
import { APP_LOGGEDIN_AGENTID } from '../constants/Constants';

const getResponseFromEncyptedText = (response) => {
  const responseStr = response.response.split('**********');
  const textToBeUsed = CryptoJS.enc.Base64.parse(responseStr[0]);
  const textToBeConverted = CryptoJS.enc.Base64.parse(responseStr[1]);
  const actualText = CryptoJS.lib.CipherParams.create({
    ciphertext: textToBeConverted,
    formatter: CryptoJS.format.OpenSSL,
  });
  const actualResponse = CryptoJS.AES.decrypt(actualText, textToBeUsed, {
    keySize: 32,
    mode: CryptoJS.mode.ECB,
    padding: CryptoJS.pad.Pkcs7,
  });
  const actualResponseJsonString = actualResponse.toString(CryptoJS.enc.Utf8);
  return JSON.parse(actualResponseJsonString);
};

export const setDataInLS = (key, value) => {
  localStorage.setItem(key, JSON.stringify(value));
};

export const getObjectFromLS = (key) => {
  const data = localStorage.getItem(key);
  if (data !== null) {
    return JSON.parse(data);
  }
  return null;
};

export const removeDataInLS = (key) => {
  localStorage.removeItem(key);
};

export const setStringInLs = (key, value) => {
  localStorage.setItem(key, value);
};

export const getStringFromLS = (key) => {
  return localStorage.getItem(key);
};

export const clearLocalStorage = () => {
  localStorage.removeItem(APP_USER_AUTH);
  localStorage.removeItem(APP_CONFIG);
  localStorage.removeItem(APP_USER_PROFILE);
  localStorage.removeItem(APP_SWITCHBACK_AUTH_TOKEN);
  localStorage.removeItem(APP_TRAIN_RETURN_BOOKING);
  localStorage.removeItem(APP_ADMIN_MESSAGE);
  localStorage.removeItem(APP_LOGGEDIN_AGENTID);
  localStorage.removeItem(APP_AGENT_LOGO_URL);
  localStorage.removeItem(APP_EMPLOYEE_EMAIL);
};

export const getPrefLanguage = () => {
  const data = localStorage.getItem(APP_PREF_LANGUAGE);
  return data !== null ? data : 'en';
};

export const getEmployeeEmail = () => {
  return localStorage.getItem(APP_EMPLOYEE_EMAIL) || '';
};

export const getUserAgentId = () => {
  try {
    const data = getObjectFromLS(APP_USER_PROFILE);
    return data.agentId;
  } catch (error) {
    return '';
  }
};

export const getUserSystemRoleId = () => {
  try {
    const data = getObjectFromLS(APP_USER_PROFILE);
    return data?.systemRoleId ? Number(data.systemRoleId) : null;
  } catch (error) {
    return null;
  }
};

export const getValueFromAppConfig = (name) => {
  const data = localStorage.getItem(APP_CONFIG);
  if (data !== null) {
    const dataConfig = JSON.parse(localStorage.getItem(APP_CONFIG));
    const hasObject = dataConfig.find(
      (obj) => obj.ConfigKey.split(' ')[1] === name,
    );
    return hasObject ? hasObject.ConfigValue : null;
  }
  return null;
};
